<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <div class="brand-logo">
            <img src="img/cloud.png" alt="Cloud AM" class="logo-img">
            <h1 class="brand-title">Cloud AM</h1>
          </div>
          <p class="login-subtitle">Secure Access Management Platform</p>
        </div>
        <div class="login-body">
          <div class="login-options">
            <a role="button" href="/sign-in" class="login-button primary-login">
              <div class="button-icon">
                <i class="fa fa-user-circle"></i>
              </div>
              <div class="button-content">
                <span class="button-title">Email Login</span>
                <span class="button-subtitle">Sign in with your account</span>
              </div>
              <i class="fa fa-arrow-right button-arrow"></i>
            </a>
            <button @click="showOktaModal" class="login-button sso-login">
              <div class="button-icon">
                <i class="fa fa-shield-alt"></i>
              </div>
              <div class="button-content">
                <span class="button-title">SSO Login</span>
                <span class="button-subtitle">Sign in with Okta</span>
              </div>
              <i class="fa fa-arrow-right button-arrow"></i>
            </button>
          </div>
        </div>
        <div class="login-footer">
          <p class="help-text">Need help? <a href="#" class="help-link">Contact Support</a></p>
        </div>
      </div>
    </div>

    <!-- Okta Login Modal -->
    <b-modal id="okta-modal" title="Login" @ok="startOktaLogin" hide-footer>
      <b-form @submit.prevent="startOktaLogin">
        <b-form-group label="Enter your email" label-for="okta-domain">
          <b-form-input
            id="okta-domain"
            v-model="oktaEmail"
            placeholder="me@example.com"
            required
          ></b-form-input>
        </b-form-group>
        <div class="text-center">
          <b-button type="submit" variant="primary" class="btn-fill mt-3">Login</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {BButton, BForm, BFormGroup, BFormInput, BModal} from 'bootstrap-vue';
import apiClient from "@/http";

export default {
  name: 'Login',
  components: {
    FontAwesomeIcon,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
  },
  data() {
    return {
      oktaEmail: '',
      oktaSettings: {
        enabled: false,
        domain: '',
        clientId: '',
        clientSecret: '',
        orgUrl: '',
        redirectUrl: '',
        orgCode : ''

      },
    };
  },
  methods: {
    showOktaModal() {
      this.$bvModal.show('okta-modal');
    },
    async startOktaLogin() {
      try {
        const response = await apiClient.post('/auth/sso/okta/properties', {
          Email: this.oktaEmail
        });
        this.oktaSettings.enabled = response.data.enabled;
        this.oktaSettings.domain = response.data.domain;
        this.oktaSettings.clientId = response.data.clientId;
        this.oktaSettings.clientSecret = response.data.clientSecret;
        this.oktaSettings.orgUrl = response.data.orgUrl;
        this.oktaSettings.redirectUrl = response.data.redirectUrl;
        this.oktaSettings.orgCode = response.data.orgCode;
        this.$bvModal.hide('okta-modal');

        const scopes = ['openid', 'profile', 'email'];
        const state = JSON.stringify({provider: 'okta', orgCode: this.oktaSettings.orgCode});
        window.location.href = `${this.oktaSettings.orgUrl}/oauth2/v1/authorize?client_id=${this.oktaSettings.clientId}&response_type=code&scope=${encodeURIComponent(scopes.join(' '))}&redirect_uri=${encodeURIComponent(this.oktaSettings.redirectUrl)}&state=${encodeURIComponent(state)}`;
      } catch (error) {
        const errorMessage = error.response && error.response.data ? error.response.data : `Error fetching okta settings`;
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }

    },
  },
};
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  padding: 20px;
  position: relative;
}

.login-container {
  width: 100%;
  max-width: 420px;
  z-index: 1;
}

.login-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  text-align: center;
}

.login-header {
  margin-bottom: 32px;
}

.brand-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

.logo-img {
  width: 64px;
  height: 64px;
  margin-bottom: 12px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.brand-title {
  font-size: 28px;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  letter-spacing: -0.5px;
}

.login-subtitle {
  color: #718096;
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}

.login-body {
  margin-bottom: 24px;
}

.login-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-button {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  background: white;
  border: 2px solid #e2e8f0;
}

.login-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.login-button:hover::before {
  left: 100%;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.primary-login {
  border-color: #3182ce;
  color: #3182ce;
}

.primary-login:hover {
  background: #3182ce;
  color: white;
  border-color: #3182ce;
}

.sso-login {
  border-color: #4299e1;
  color: #4299e1;
}

.sso-login:hover {
  background: #4299e1;
  color: white;
  border-color: #4299e1;
}

.button-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  margin-right: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.sso-login .button-icon {
  background: #f7fafc;
}

.button-icon i {
  font-size: 20px;
}

.button-content {
  flex: 1;
  text-align: left;
}

.button-title {
  display: block;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
  margin-bottom: 4px;
}

.button-subtitle {
  display: block;
  font-size: 14px;
  opacity: 0.7;
  font-weight: 400;
}

.button-arrow {
  font-size: 16px;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.login-button:hover .button-arrow {
  transform: translateX(4px);
  opacity: 1;
}

.login-button:hover .button-icon {
  background: rgba(255, 255, 255, 0.9);
  transform: scale(1.02);
}

.login-footer {
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.help-text {
  color: #718096;
  font-size: 14px;
  margin: 0;
}

.help-link {
  color: #3182ce;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.help-link:hover {
  color: #2b77cb;
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 480px) {
  .login-page {
    padding: 16px;
  }
  
  .login-card {
    padding: 24px;
    border-radius: 16px;
  }
  
  .brand-title {
    font-size: 24px;
  }
  
  .login-button {
    padding: 16px 20px;
  }
  
  .button-icon {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }
  
  .button-icon i {
    font-size: 18px;
  }
  
  .button-title {
    font-size: 15px;
  }
  
  .button-subtitle {
    font-size: 13px;
  }
}

/* Modal Enhancements */
::v-deep .modal-content {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

::v-deep .modal-header {
  border-bottom: 1px solid #e2e8f0;
  padding: 20px;
}

::v-deep .modal-body {
  padding: 20px;
}

::v-deep .modal-title {
  font-weight: 600;
  color: #2d3748;
}

::v-deep .btn-primary {
  background: #3182ce;
  border: 1px solid #3182ce;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.2s ease;
}

::v-deep .btn-primary:hover {
  background: #2b77cb;
  border-color: #2b77cb;
}

::v-deep .form-control {
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  transition: all 0.3s ease;
}

::v-deep .form-control:focus {
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}
</style>
